export const cleanTicker = (ticker: string): string => {
    return ticker.replace(/[^a-zA-Z0-9.]/g, '').toUpperCase();
};